import React from 'react';
import FinalFormRadioWrapper from './FinalFormRadioWrapper';
import { RadiobuttonCard } from 'components/forms';
import { FieldRenderProps } from 'react-final-form';

export interface WrapperProps extends FieldRenderProps<string> {}

const TextInputWrapper: React.FC<WrapperProps> = (props) => (
  <FinalFormRadioWrapper {...props} component={RadiobuttonCard} />
);

export default TextInputWrapper;
